// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1AreR","loaderOuter":"PageOverlayLoader_loaderOuter__3V6I0"};